(function ($) {
    $(document).ready(function () {
        //dropdowns select behaviour
        $('.js-dropdown').on('click', 'a', function (e) {
            e.preventDefault();
            $(this).closest('div')
                .find('.js-dropdown-select')
                    .text($(this).text())
                    .data('value', $(this).data('value'));
        });

        $('.js-toggle').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            $collapse = $this.parent().find('.js-toggle-data');
            $collapse.collapse('toggle');
        });
    });
})(jQuery);